import BrandIcon from '@/sections/BrandIcon'
import i18n from '@/locales'
export default {
  created () {
    this.columns = [
      {
        field: 'id',
        title: 'ID',
        minWidth: 100,
        slots: {
          default: ({ row }, h) => {
            return [<list-body-cell-wrap copy hideField row={ row } field='id' title={ row.id + '' } message={ row.id + '' } >
              <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.id + ''}</side-page-trigger>
            </list-body-cell-wrap>]
          },
        },
      },
      {
        field: 'name',
        title: i18n.t('op_48'),
        minWidth: 100,
      },
      {
        field: 'sku',
        title: 'SKU',
        minWidth: 100,
      },
      {
        field: 'sku_service',
        title: i18n.t('op_30'),
        minWidth: 100,
      },
      {
        field: 'provider',
        title: i18n.t('op_83'),
        slots: {
          default: ({ row }, h) => {
            const val = row.provider
            if (!val) return '-'
            if (val === '__all__') return i18n.t('op_84')
            return [
              <BrandIcon name={ val } />,
            ]
          },
        },
      },
      {
        field: 'region',
        title: i18n.t('op_45'),
        formatter: ({ cellValue }) => {
          if (cellValue === '__all__') return i18n.t('op_84')
          return cellValue
        },
      },
      {
        field: 'customer',
        title: i18n.t('op_85'),
        formatter: ({ row, cellValue }) => {
          if (row.customer_id === '__all__') return i18n.t('op_84')
          return cellValue
        },
      },
      {
        field: 'cloudaccount_id',
        title: i18n.t('op_46'),
        formatter: ({ cellValue }) => {
          if (cellValue === '__all__') return i18n.t('op_84')
          return cellValue
        },
      },
      {
        field: 'start_units',
        title: i18n.t('op_86'),
      },
      {
        field: 'rate',
        title: i18n.t('op_69'),
        formatter: ({ row, cellValue }) => {
          const value = row.rate_type === 'amount' ? cellValue : cellValue * 100
          const currencyZh = row.currency === 'USD' ? i18n.t('op_68') : i18n.t('op_67')
          const unit = row.unit ? `/${row.unit}` : ''
          return `${value}${row.rate_type === 'amount' ? currencyZh : '%'}${unit}`
        },
      },
      {
        field: 'rate_type',
        title: i18n.t('op_87'),
        formatter: ({ cellValue }) => {
          const ret = {
            percent: i18n.t('op_60'),
            amount: i18n.t('op_61'),
          }
          return ret[cellValue]
        },
      },
    ]
  },
}
